import React from 'react';

import { useAtom } from 'jotai';
import { secondaryTimezone as secondaryTimezoneAtom } from '@/lib/atoms/secondary-timezone';
import { PBSTimezones } from '@/lib/types/api/timezones';

import styles from '@/components/TimezoneToggle/TimezoneToggle.module.scss'

type TimezoneToggleProps = {
  secondaryTimezone: PBSTimezones;
  displayPrimaryTimezone: string;
  displaySecondaryTimezone: string;
}

const TimezoneToggle: React.FC<TimezoneToggleProps> = (props) => {
  const { displayPrimaryTimezone, displaySecondaryTimezone } = props;
  const [secondaryTimezone, setSecondaryTimezone] = useAtom(secondaryTimezoneAtom)

  return (
    <React.Fragment>
      <span className={styles.intro}>Timezone:</span>
      <span className={styles.toggle_bg}>
        <button
          onClick={() => setSecondaryTimezone(null)}
          className={styles.timezone_toggle__btn}
          type={`button`}
          disabled={secondaryTimezone ? false : true}
          aria-pressed={secondaryTimezone ? false : true}
          aria-label={`Change TV schedules timezone to ${displayPrimaryTimezone}`}
        >
          <span className={styles.primary}>{displayPrimaryTimezone}</span>
        </button>
          <React.Fragment>
            <button
              onClick={() => setSecondaryTimezone(props.secondaryTimezone)}
              className={styles.timezone_toggle__btn}
              type={`button`}
              disabled={secondaryTimezone ? true : false}
              aria-pressed={secondaryTimezone ? true : false}
              aria-label={`Change TV schedules timezone to ${displaySecondaryTimezone}`}
            >
              <span className={styles.secondary}>{displaySecondaryTimezone}</span>
            </button>
          </React.Fragment>
      </span>
    </React.Fragment>
  );
};

export default TimezoneToggle;
